import {onMounted, onUnmounted, ref} from "vue";
import {eventBus} from "@/Composables";

function slugify(str) {
    if (!str) return;

    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export default function useFileList() {

    //If an upload fails for a file in the list... remove it
    const onUploadFileError = (file) => removeFile(file);

    onMounted(() => {
        //Events Listener
        eventBus.on("file-list:clear", clearList)

        //External Events
        eventBus.on("uploadFile:error", onUploadFileError)
    })

    onUnmounted(() => {
        //Events Listener
        eventBus.off("file-list:clear", clearList)

        //External Events
        eventBus.off("uploadFile:error", onUploadFileError)
    })

    const files = ref([]);

    function addFiles(newFiles) {
        let newUploadableFiles = [...newFiles]
            .map((file) => new UploadableFile(file))
            .filter((file) => !fileExists(file.id));
        files.value = files.value.concat(newUploadableFiles);
        broadcast_files();
    }

    function fileExists(otherId) {
        return files.value.some(({ id }) => id === otherId);
    }

    function removeFile(file) {
        const index = files.value.indexOf(file);
        if (index > -1) {
            files.value.splice(index, 1);
        }
        broadcast_files()
    }

    function clearList() {
        files.value = [];
        broadcast_files()
    }

    function broadcast_files() {
        eventBus.emit("file-list:files", files.value);
    }

    return {
        files,
        addFiles,
        removeFile,
        clearList
    };
}

class UploadableFile {
    constructor(file) {
        this.file = file;
        this.type = file.type;
        this.name = file.name;
        this.id = `${slugify(file.name)}-${file.size}-${file.lastModified}`;
        this.url = URL.createObjectURL(file);
        this.status = null;
        this.uploadProgress = 0;
        this.saved = false;
    }
}
